var tri = require("tripartite"); var t = "<div class=\"website-line\">\n\t<a href=\"__this__\">__this__<\/a>\n<\/div>"; 
module.exports = tri.addTemplate("views/search-client/website-line", t); 